import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ILlm } from 'llm-config';

@Component({
    selector: 'app-llm-select',
    templateUrl: './llm-select.component.html',
    styleUrls: ['./llm-select.component.scss'],
    standalone: false
})
export class LlmSelectComponent {
  @Input() set LLMs(LLMs: string | string[]) {
    this.setLLMsSelected(LLMs);
  }
  @Input() LLMList!: ILlm[];
  @Input() multiSelect = false;
  @Input() defaultLLM!: string;

  @Output() selectionChange = new EventEmitter<string | string[]>();
  @Output() defaultLLMChange = new EventEmitter<{LLM: string, event: any}>();

  protected LLMsSelected: string | string[] = '';
  protected LLMsListTooltip = '';

  constructor() {
  }

  protected setLLMsSelected(LLMs: string | string[]) {
    this.LLMsSelected = LLMs;
    this.LLMsListTooltip = this.buildTooltip();
  }

  protected LLMSelectionChange($event: any): void {
    this.LLMsSelected = $event.value;
    this.LLMsListTooltip = this.buildTooltip();
    this.selectionChange.emit(this.LLMsSelected);
  }

  private buildTooltip() {
    const tooltipItems = this.LLMsSelected.length > 0 ? this.LLMsSelected : ['No LLM selected'];
    if (Array.isArray(tooltipItems)) {
      return tooltipItems?.join(', ');
    } else {
      return tooltipItems;
    }
  }

  updateDefaultLLM(LLM: ILlm, $event: any) {
    this.defaultLLMChange.emit({LLM: LLM.name, event: $event});
  }

}
